import React, { useMemo, useState } from "react";

import {
    AppleOutlined,
    SearchOutlined,
    RightOutlined,
    FireOutlined,
    DashboardOutlined,
    ExperimentOutlined,
    SwapOutlined,
    SafetyCertificateOutlined
} from "@ant-design/icons";

import {
    nutritionTools,
    nutritionGroups
} from "./tools";


const getIcon = (group) => {

    switch (group) {

        case "Năng lượng":
            return <FireOutlined />;

        case "Protein & macro":
            return <ExperimentOutlined />;

        case "Nước":
            return <DashboardOutlined />;

        case "Quy đổi":
            return <SwapOutlined />;

        default:
            return <AppleOutlined />;
    }
};


export default function TienIchDinhDuong() {

    const [search, setSearch] =
        useState("");

    const [group, setGroup] =
        useState("Tất cả");


    const filteredTools =
        useMemo(() => {

            const keyword =
                search
                    .trim()
                    .toLocaleLowerCase(
                        "vi"
                    );

            return nutritionTools.filter(
                (tool) => {

                    const groupOk =
                        group === "Tất cả" ||
                        tool.group === group;

                    const text =
                        `${tool.name} ${tool.shortName} ${tool.description} ${tool.group}`
                            .toLocaleLowerCase(
                                "vi"
                            );

                    const searchOk =
                        !keyword ||
                        text.includes(
                            keyword
                        );

                    return (
                        groupOk &&
                        searchOk
                    );
                }
            );

        }, [search, group]);


    return (

        <div className="max-w-screen-2xl mx-auto px-3 md:px-5 pt-16 md:pt-4 pb-10">


            <div className="relative overflow-hidden bg-gradient-to-r from-emerald-700 via-green-600 to-lime-500 rounded-2xl px-5 py-6 md:p-9 text-white">

                <div className="relative z-10 max-w-3xl">

                    <div className="flex items-center">

                        <div className="w-12 h-12 md:w-14 md:h-14 rounded-2xl bg-white bg-opacity-20 flex items-center justify-center text-2xl">

                            <AppleOutlined />

                        </div>


                        <div className="ml-4">

                            <p className="text-[11px] md:text-sm font-semibold opacity-90">

                                TIỆN ÍCH Y KHOA

                            </p>


                            <h1 className="text-[27px] md:text-3xl font-bold">

                                Bộ công cụ Dinh dưỡng

                            </h1>

                        </div>

                    </div>


                    <p className="text-[14px] md:text-base leading-6 mt-4 opacity-90">

                        Công cụ hỗ trợ tính toán cân nặng, chuyển hóa,
                        năng lượng, protein, nước và phân bổ dưỡng chất.

                    </p>


                    <div className="bg-white rounded-2xl h-12 flex items-center px-4 mt-5">

                        <SearchOutlined className="text-gray-400" />


                        <input
                            value={search}
                            onChange={(e) =>
                                setSearch(
                                    e.target.value
                                )
                            }
                            placeholder="Tìm BMI, RMR, protein, macro..."
                            className="flex-1 ml-3 outline-none text-gray-700 text-sm bg-transparent"
                        />

                    </div>

                </div>

            </div>


            <div className="overflow-x-auto mt-5 pb-1">

                <div className="flex gap-2 min-w-max">

                    {nutritionGroups.map(
                        (item) => (

                            <button
                                key={item}
                                type="button"
                                onClick={() =>
                                    setGroup(item)
                                }
                                className={`
                                    rounded-full
                                    px-4 py-2
                                    text-[12px] md:text-sm
                                    font-semibold
                                    border
                                    transition
                                    ${
                                        group === item
                                            ? "bg-emerald-600 text-white border-emerald-600"
                                            : "bg-white text-gray-600 border-gray-200"
                                    }
                                `}
                            >

                                {item}

                            </button>

                        )
                    )}

                </div>

            </div>


            <div className="mt-6">

                <h2 className="text-[21px] md:text-2xl font-bold text-gray-900">

                    {group === "Tất cả"
                        ? "Tất cả công cụ"
                        : group
                    }

                </h2>


                <p className="text-gray-500 text-[13px] mt-1">

                    {filteredTools.length} công cụ

                </p>

            </div>


            {filteredTools.length > 0 ? (

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4 mt-4">

                    {filteredTools.map(
                        (tool) => (

                            <a
                                key={tool.slug}
                                href={`/tienich/dinh-duong/${tool.slug}`}
                                className="group bg-white border border-gray-200 rounded-2xl p-4 md:p-5 block text-black hover:border-emerald-200 hover:shadow-lg transition"
                            >

                                <div className="flex items-start">

                                    <div className="w-11 h-11 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center text-xl flex-shrink-0">

                                        {getIcon(
                                            tool.group
                                        )}

                                    </div>


                                    <div className="ml-3 flex-1 min-w-0">

                                        <div className="flex items-start justify-between">

                                            <h3 className="font-bold text-[14px] md:text-base text-gray-900 leading-5">

                                                {tool.name}

                                            </h3>


                                            <RightOutlined className="text-gray-300 text-xs ml-2 mt-1 group-hover:text-emerald-500" />

                                        </div>


                                        <p className="text-[10px] font-semibold text-emerald-600 mt-1">

                                            {tool.group}

                                        </p>

                                    </div>

                                </div>


                                <p className="text-[12px] md:text-[13px] text-gray-500 leading-5 mt-3">

                                    {tool.description}

                                </p>

                            </a>

                        )
                    )}

                </div>

            ) : (

                <div className="bg-white border rounded-2xl text-center py-12 mt-4">

                    <SearchOutlined className="text-3xl text-gray-300" />


                    <p className="font-bold text-gray-700 mt-3">

                        Không tìm thấy công cụ

                    </p>

                </div>

            )}


            <div className="bg-emerald-50 border border-emerald-100 rounded-2xl p-4 md:p-5 mt-8">

                <div className="flex items-start">

                    <SafetyCertificateOutlined className="text-emerald-600 text-xl mt-0.5" />


                    <div className="ml-3">

                        <p className="font-bold text-gray-800">

                            Lưu ý khi sử dụng

                        </p>


                        <p className="text-[13px] md:text-sm text-gray-600 leading-6 mt-1">

                            Các công cụ dinh dưỡng trên website dùng để tính toán,
                            theo dõi và tham khảo. Không dùng kết quả đơn lẻ để
                            tự điều trị hoặc xây dựng chế độ ăn cho người có bệnh lý,
                            phụ nữ mang thai, trẻ em hoặc người có nhu cầu dinh dưỡng đặc biệt.

                        </p>

                    </div>

                </div>

            </div>

        </div>
    );
}
